import type { ProductSigningStatus } from "@sveabank/cc-common";
import { onboardingApi } from ".";
import type { SigningStatus } from "../types/signing";
import {
	cancelSign,
	fetchSigningStatus,
	initializeGuarantorSigning,
	initializePackageSigning,
} from "./endpoints/signing";

const signingSlice = onboardingApi.injectEndpoints({
	endpoints: (builder) => ({
		initializeGuarantorSigning: builder.mutation<
			ProductSigningStatus,
			{
				applicationId: string;
			}
		>({
			query: ({ applicationId }) => initializeGuarantorSigning(applicationId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: false,
				withAuth: true,
			},
		}),
		initializePackageSigning: builder.mutation<
			ProductSigningStatus,
			{
				applicationId: string;
			}
		>({
			query: ({ applicationId }) => initializePackageSigning(applicationId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: false,
				withAuth: true,
			},
		}),
		getSigningStatus: builder.mutation<
			SigningStatus,
			{
				applicationId: string;
			}
		>({
			query: ({ applicationId }) => fetchSigningStatus(applicationId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: true,
				withAuth: true,
			},
		}),
		cancelSign: builder.mutation<void, string>({
			query: (applicationId) => cancelSign(applicationId),
			extraOptions: {
				revision: true,
				allowRevisionConflict: true,
				withAuth: true,
			},
		}),
	}),
});

export const {
	useGetSigningStatusMutation,
	useInitializeGuarantorSigningMutation,
	useInitializePackageSigningMutation,
	useCancelSignMutation,
} = signingSlice;
